/**
 * Birch Lane SVG logo
 *
 * @author    Steve Dennett <sdennett@wayfair.com>
 * @copyright 2018 Wayfair LLC - All rights reserved
 */
import React from 'react';
import BaseLogo from './BaseLogo';

// The unique aspect ratio of the Birch store logo, this ensures consistent height based off of the width
const ASPECT_RATIO = 0.1675;

const BirchLogo = (props) => {
  return (
    <BaseLogo
      {...props}
      aspectRatio={ASPECT_RATIO}
      aria-label="Birch Lane"
      viewBox="0 0 200 33.5"
      fill="#112E58"
    >
      <title>Birch Lane</title>
      <g>
        <path
          d="M65.1,21.2c-0.4,0.5-0.7,0.8-1.3,1.2c-0.9,0.6-2.1,0.9-3.2,0.9s-2.2-0.2-3.1-0.9s-1.2-1.7-1.3-2.8
		C56,18.8,56,17.9,56,17v-0.1v-0.1c0-1,0-1.9,0.2-2.6c0.2-1,0.5-2.1,1.3-2.8c0.9-0.6,2-0.9,3.1-0.9s2.3,0.3,3.2,0.9
		c0.5,0.4,0.9,0.7,1.3,1.2c0.3,0.4,0.5,0.5,0.6,0.9l1.3-0.7c-0.2-0.3-0.4-0.6-0.6-0.9C65,10.1,63,9.2,60.6,9.2c-1.5,0-2.9,0.4-4.2,1
		c-1.3,0.7-2.4,1.6-3.1,2.8s-1.2,2.4-1.2,3.8v0v0c0,1.4,0.4,2.6,1.2,3.8c0.8,1.2,1.8,2.1,3.1,2.8c1.3,0.7,2.7,1,4.2,1
		c2.4,0,4.3-0.9,5.8-2.6c0.2-0.3,0.5-0.6,0.6-0.9l-1.3-0.7C65.5,20.6,65.4,20.8,65.1,21.2z"
        />
        <rect x="21.1" y="9.4" width="3.1" height="14.8" />
        <path d="M84.2,15.9h-8V9.4h-3.1c0,0.4,0,14.3,0,14.8h3.1v-6.9h8v6.9h3.1V9.4h-3.1V15.9z" />
        <path
          d="M47.3,13.3c0-2.8-2.5-4-6.4-4h-5.5l0,0h-3.1v14.8h3.1v-6.9h3.5l5,6.9h3.8c0,0-4.3-5.7-5.2-7
		C45.2,16.9,47.3,15.9,47.3,13.3z M35.4,15.9v-5c0,0,5.3-0.3,6.8,0.2c1.5,0.5,2,1.1,2.1,2.3c0,1.4-0.7,1.9-2,2.4
		C41.1,16.1,35.4,15.9,35.4,15.9z"
        />
        <path
          d="M9.3,16.6c2.5-0.4,4.2-1.5,4.2-3.5c0-2.6-2.9-3.7-7.3-3.7H0v14.8h6.5c4.3,0,7.7-1,7.7-3.9
		C14.2,18.2,12.3,17,9.3,16.6z M3.1,10.8c0.1,0,4.5-0.3,5.7,0.3c0.7,0.3,1.4,0.7,1.5,2.1c0,1.2-0.5,1.7-1.5,2.1
		c-1.5,0.4-5.7,0.3-5.7,0.3V10.8z M9,22.5c-1.1,0.5-5.8,0.3-5.8,0.3v-6h3.5c2.5,0,4.1,0.7,4.1,3.2C10.7,21.4,10.1,22,9,22.5z"
        />
        <polygon
          points="178.7,19 169.3,9.4 166.5,9.4 166.5,24.2 167.9,24.2 167.9,12.2 179.6,24.2 180.1,24.2 180.1,9.4
		178.7,9.4 	"
        />
        <path d="M153,9.1l-6.8,15.1h1.6l1.8-4h6.1l1.8,4h3.1l-6.8-15.1L153,9.1z M150.1,18.7l2.4-5.4l2.5,5.4H150.1z" />
        <polygon
          points="190.1,22.8 190.1,17.3 196.3,17.3 196.3,15.9 190.1,15.9 190.1,10.8 200,10.8 200,9.4 186.9,9.4
		186.9,24.2 200,24.2 200,22.8 	"
        />
        <polygon points="131.5,22.8 131.5,9.4 128.4,9.4 128.4,24.2 141.5,24.2 141.5,22.8 	" />
        <g>
          <path
            d="M118.1,18.6c0-7.1-9.3-17.3-9.7-17.7l-0.7-0.8L107,0.9c-0.4,0.4-9.3,10.7-9.3,17.7c0,6.5,7.2,9.7,9.2,10.5
			c0,0.8,0,2.5,0,2.6c0,0.9-1,1.9-1,1.9h3.8c0,0-1-1-1-1.9c0,0,0-1.8,0-2.6C110.7,28.3,118.1,25,118.1,18.6z M108.5,9.5
			c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8v4.9l-2.2-2.2c-0.3-0.3-0.9-0.3-1.2,0c-0.3,0.3-0.3,0.9,0,1.2l3.4,3.4
			c0,1.5,0,2.8,0,4.4l-3.7-3.5c-0.3-0.3-0.9-0.3-1.2,0c-0.3,0.3-0.3,0.9,0,1.2l4.9,4.8c0,1.2,0,2.4,0,3.4c-2.3-1-7.3-3.8-7.3-8.4
			c0-5.2,6.1-13.1,8.1-15.6c2.2,2.5,8.5,10.3,8.5,15.6c0,4.7-5.3,7.4-7.6,8.5c0-1,0-2.1,0-3.4l4.9-4.8c0.3-0.3,0.3-0.9,0-1.2
			s-0.9-0.3-1.2,0l-3.7,3.5c0-1.6,0-2.9,0-4.4l3.4-3.4c0.3-0.3,0.3-0.9,0-1.2s-0.9-0.3-1.2,0l-2.2,2.2L108.5,9.5z"
          />
        </g>
      </g>
    </BaseLogo>
  );
};

export default BirchLogo;
